import IBAN from 'iban';
import _ from 'lodash';
import { BaseController } from '../../common/base/controller';

export class InboxController extends BaseController {
  constructor(
    controllerService,
    $q,
    jobService,
    IbanPrefix,
    DocumentStatus,
    DocumentTypes,
    inboxDocumentService,
    needsConfirmationService,
    InboxTabs,
    $scope,
    notificationService,
  ) {
    'ngInject';
    super({
      controllerService,
      $q,
      jobService,
      IbanPrefix,
      DocumentStatus,
      DocumentTypes,
      needsConfirmationService,
      inboxDocumentService,
      InboxTabs,
      $scope,
      notificationService,
    });
  }

  get docImageUrl() {
    return this.inboxDocumentService.docImageUrl;
  }

  get showDeleteJob() {
    return this.inboxDocumentService.selectedDocument;
  }

  get showFaxCategoryPanel() {
    return (
      this.inboxDocumentService.selectedDocument &&
      (this.inboxType === this.InboxTabs.OPEN ||
        this.inboxType === this.InboxTabs.NEED_CLARIFICATON)
    );
  }

  get showArchiveRejectedPanel() {
    return (
      this.inboxDocumentService.selectedDocument &&
      this.inboxType === this.InboxTabs.REJECTED
    );
  }

  get showArchiveDetails() {
    return (
      this.inboxDocumentService.selectedDocument.archive &&
      this.inboxDocumentService.selectedDocument.archive.archivedBy &&
      this.inboxDocumentService.selectedDocument.archive.archivedAt
    );
  }

  get innerTempDocument() {
    return this.inboxDocumentService.innerTempDocument;
  }

  $onInit() {
    this.form = {};
  }

  validateIBAN(key, prefix = this.IbanPrefix) {
    const { form } = this;

    // Need to add prefix if the value has no prefix
    const ibanValue = prefix + this.inboxDocumentService.envelope[key];

    // Set the form control validation value; An empty iban is also valid in a way
    form[key].$valid = IBAN.isValid(ibanValue.toUpperCase());
  }

  submitModel() {
    // force form validation of required fields.
    this.form.$setSubmitted(true);

    if (
      this.form.$invalid ||
      !this.innerTempDocument ||
      !this.innerTempDocument.envelope ||
      !this.innerTempDocument.envelope.documentType
    ) {
      return;
    }

    // Create a copy of the model to prevent changes made by adding field prefixes
    let envelope = angular.copy(this.innerTempDocument.envelope);
    let ticketId = this.innerTempDocument._id;
    if (this.isDocumentIncompleteWithoutIban()) {
      this.leanSubmit(envelope, ticketId);
    } else {
      this.standardSubmit(
        envelope,
        ticketId,
        this.innerTempDocument.aidRequestId || null,
      );
    }
  }

  isDocumentIncompleteWithoutIban() {
    return (
      this.innerTempDocument.envelope.rejectionReason ===
      this.DocumentStatus.INCOMPLETE_WITHOUT_IBAN
    );
  }

  standardSubmit(envelope, ticketId, aidRequestId) {
    // Validate given ibans
    this.validateIBAN('oldIban');
    this.validateIBAN('newIban');

    // Submit only a valid form
    if (!this.form.$valid) {
      return;
    }

    let submitData = {
      documentType: envelope.documentType,
      oldIban: envelope.oldIban,
      newIban: envelope.newIban,
      aidRequestId,
    };

    this.mayBeAddRejectionReason(envelope, submitData);

    if (
      envelope.documentType ||
      !this.areRequiredSubmitFieldsMissing(submitData)
    ) {
      this.jobService
        .updateJob(ticketId, submitData)
        .then(() => {
          this.$scope.$broadcast('initDocumentListController');
        })
        .catch((err) => this.onSubmitFail(err));
    }
  }

  // only for document typ 'OTHER'
  leanSubmit(envelope, ticketId) {
    if (!envelope.documentType) {
      return;
    }

    let submitData = {
      documentType: envelope.documentType,
    };

    this.mayBeAddRejectionReason(envelope, submitData);

    this.jobService
      .updateJob(ticketId, submitData)
      .then(() => {
        this.$scope.$broadcast('initDocumentListController');
      })
      .catch((err) => this.onSubmitFail(err));
  }

  submitCommentForRejectedJob() {
    const selectedDocument = this.inboxDocumentService.selectedDocument;

    if (
      !selectedDocument.archive ||
      selectedDocument.archive.archiveNote.trim() === ''
    ) {
      return;
    }

    this.jobService
      .submitCommentForRejectedJobs(selectedDocument._id, {
        archiveNote: selectedDocument.archive.archiveNote.trim(),
      })
      .then(() => {
        // reset current job
        this.inboxDocumentService.selectedDocument = {};
      });
  }

  deleteJob() {
    _.defaults(this.$scope, {
      confirmTitle: 'inbox.deleteJob.modal.title',
      confirmBody: 'inbox.deleteJob.modal.body',
      confirmDismiss: 'inbox.deleteJob.modal.dismiss',
      confirmOk: 'inbox.deleteJob.modal.confirm',
    });

    const ticketId = this.innerTempDocument._id;

    // show dialog uiModalDeclarationService
    this.needsConfirmationService.open({
      onSuccess: () => {
        this.jobService.deleteJob(ticketId).then(() => {
          this.$window.location.reload();
        });
      },
      scope: this.$scope,
    });
  }

  mayBeAddRejectionReason(envelope, submitData) {
    if (envelope.rejectionReason) {
      // Handle already closed tickets (currently we reject jobs for closed ticket with status OTHER)
      if (this.jobService.isJobClosed(this.innerTempDocument)) {
        submitData.rejectionReason = this.DocumentStatus.OTHER;
      } else {
        // Set a non-ok status as rejection reason
        submitData.rejectionReason = envelope.rejectionReason;
      }

      // Add new rejectionReasonText when given
      if (envelope.rejectionReasonText) {
        submitData.rejectionReasonText = envelope.rejectionReasonText;
      }
    }
  }

  maybeInitializeArchive() {
    if (!this.inboxDocumentService.selectedDocument.archive) {
      this.inboxDocumentService.selectedDocument.archive = {};
    }
  }

  onSubmitFail(err) {
    const { data } = err;
    if (data.errorMessage === 'NO_TICKET_FOUND') {
      this.notificationService.error('inbox.error.NO_TICKET_FOUND');
      return;
    }
    this.notificationService.error('app.error.unknown', err);
  }

  areRequiredSubmitFieldsMissing(data) {
    return _.some(data, (e, key) => {
      // ignore iban fields if documentType is MISC because we need no iban in this case.
      if (
        data.documentType === this.DocumentTypes.MISC &&
        (key === 'oldIban' || key === 'newIban')
      ) {
        return false;
      }
      return e === null;
    });
  }
}
